import React__default from 'react';
import styled from '../../../../../../node_modules/@mui/material/styles/styled.mjs';

const TableActionsContainer = styled('div')(({ theme })=>({
        display: 'flex',
        gap: theme.spacing(1),
        margin: theme.spacing(0, -1.25)
    }));
const TABLE_ACTIONS_HEADER = 'Actions';
const TableActionsCore = ({ warningAction, action, customAction, ButtonComponent: Button })=>{
    return /*#__PURE__*/ React__default.createElement(TableActionsContainer, null, action && /*#__PURE__*/ React__default.createElement(Button, {
        compact: true,
        onClick: action.onClick,
        variant: "text"
    }, action.text), warningAction && /*#__PURE__*/ React__default.createElement(Button, {
        compact: true,
        onClick: warningAction.onClick,
        variant: "text",
        warning: true
    }, warningAction.text), customAction);
};

export { TABLE_ACTIONS_HEADER, TableActionsContainer, TableActionsCore };
//# sourceMappingURL=TableActions.mjs.map
